/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe9a089e1f04f18f538500f4f4d79587>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "LayoutTwoColumnsSidebarLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const LayoutTwoColumnsSidebarLeftIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-7.75C6.115 1 5.5 1.616 5.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h7.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11H7v-11zM4 2.375C4 1.615 3.384 1 2.625 1h-1.25C.615 1 0 1.616 0 2.375v11.25C0 14.385.616 15 1.375 15h1.25C3.385 15 4 14.384 4 13.625zM2.5 2.5v11h-1v-11z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
var _default = exports.default = LayoutTwoColumnsSidebarLeftIcon;